import { API_URL, axios } from "./axiosSettings";
import { getAuthToken } from "../helpers/session";
import { logger } from "./logger";
import { convertStreamToJson } from "../util/buffer";
import { mapEnginePosition } from "../helpers/enginePosition";

export const fetchMainEngineData = async (
  position,
  vessel_id,
  startDate,
  endDate,
  interval,
  signal = null
) => {
  try {
    const fetchUrl = `${API_URL}/engineData/vesselMainEngineData?vessel_id=${vessel_id}`
    + `&startDate=${startDate}&endDate=${endDate}&position=${position}&minuteInterval=${interval}`;
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      signal,
      responseType: "stream",
    });
    const data = await convertStreamToJson(response.body);

    const mappedData = mapEnginePosition(data);

    return {
      vesselMainEngineData: mappedData,
    };
  } catch (e) {
    throw { fetchMainEngineData: e };
  }
};

export const fetchFOCEngineData = async (vessel_id, startDate, endDate, interval) => {
  try {
    const { data } = await axios.get(`/engineData/vesselFOCEngineData`, {
      params: {
        vessel_id,
        startDate,
        endDate,
        minuteInterval: interval,
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    logger.info({ vessel_id, startDate, endDate, interval });

    return { vesselEngineData: data };
  } catch (e) {
    throw { fetchEngineData: e };
  }
};

export const fetchEngineData = async (vessel_id, startDate, endDate, interval, signal) => {
  try {
    const fetchUrl = `${API_URL}/engineData/vesselEngineData?vessel_id=${vessel_id}`
    + `&startDate=${startDate}&endDate=${endDate}&minuteInterval=${interval}`;
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      signal,
      responseType: "stream",
    });
    const data = await convertStreamToJson(response.body);
    return {
      vesselEngineData: data,
    };
  } catch (e) {
    throw { fetchEngineData: e };
  }
};

export const fetchGeneratorEngineData = async ({
  vesselId,
  startDate,
  endDate,
  interval,
  generatorNumber = null, // can be null
  signal,
}) => {
  try {
    logger.info({ vesselId, startDate, endDate });
    const fetchUrl = `${API_URL}/engineData/vesselGeneratorEngineData?vessel_id=${vesselId}`
    + `&startDate=${startDate}&endDate=${endDate}&minuteInterval=${interval}`
    + (generatorNumber===null ? "" : `&generatorNumber=${generatorNumber}`);
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      signal,
      responseType: "stream",
    });
    const data = await convertStreamToJson(response.body);
    return {
      loadingData: data,
    };
  } catch (e) {
    logger.error(`generated error ${JSON.stringify(e)}`);
    throw { fetchGeneratorEngine: e };
  }
};

export const fetchGeneratorEngineDataWithLimit = async ({
  vesselId,
  startDate,
  endDate,
  interval,
  generatorNumber = null, //can be null
  limit,
}) => {
  try {
    const fetchUrl = `${API_URL}/engineData/vesselGeneratorEngineData?vessel_id=${vesselId}`
    + `&startDate=${startDate}&endDate=${endDate}&minuteInterval=${interval}&limit=${limit}`
    + (generatorNumber===null ? "" : `&generatorNumber=${generatorNumber}`);
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      responseType: "stream",
    });
    const data = await convertStreamToJson(response.body);
    return { loadingData: data };
  } catch (e) {
    logger.error(`generated error ${JSON.stringify(e)}`);
    throw { fetchGeneratorEngine: e };
  }
};

export const fetchShaftGeneratorEngineData = async ({
  vesselId,
  startDate,
  endDate,
  interval,
  generatorNumber = null,
  signal = null,
}) => {
  try {
    const fetchUrl = `${API_URL}/engineData/vesselShaftGeneratorEngineData?vessel_id=${vesselId}`
    + `&startDate=${startDate}&endDate=${endDate}&generatorNumber=${generatorNumber}&minuteInterval=${interval}`;
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      responseType: "stream",
      signal,
    });
    const data = await convertStreamToJson(response.body);
    return { loadingData: data };
  } catch (e) {
    logger.error(`generated error ${JSON.stringify(e)}`);
    throw { fetchShaftGenerator: e };
  }
};
